'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (store, layout) {
    var xAxis = void 0;

    switch (layout.type) {
        case _.CHART_TYPE_GAUGE:
            xAxis = (0, _gauge2.default)();
            break;
        default:
            xAxis = getDefault(store, layout);
    }

    return xAxis;
};

var _objectClean = require('d2-utilizr/lib/objectClean');

var _objectClean2 = _interopRequireDefault(_objectClean);

var _getAxisTitle = require('../getAxisTitle');

var _getAxisTitle2 = _interopRequireDefault(_getAxisTitle);

var _getCategories = require('../getCategories');

var _getCategories2 = _interopRequireDefault(_getCategories);

var _gauge = require('./gauge');

var _gauge2 = _interopRequireDefault(_gauge);

var _ = require('..');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDefault(store, layout) {
    return (0, _objectClean2.default)({
        categories: (0, _getCategories2.default)(store, layout),
        title: (0, _getAxisTitle2.default)(layout.domainAxisTitle),
        labels: {
            style: {
                color: '#666',
                textShadow: '0 0 #ccc'
            }
        }
    });
}
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/xAxis/index.js
 ** module id = 208
 ** module chunks = 0 1
 **/